<template>
  <div v-if="allowedGroupId.includes(groupId)" class="sales-banner">
    <h2 class="sales-banner__title">{{ mess.sales_banner_title }}</h2>
    <p class="sales-banner__subtitle sales-banner__subtitle_italic">{{ mess.sales_banner_subtitle }}</p>
    <a href="/sales" class="sales-banner__button sales-banner__button_outline">{{ mess.sales_banner_button }}</a>
  </div>
</template>

<script>
export default {
  name: "SalesBanner",
  props: {
    groupId: {
      type: Number,
      required: true
    },
    allowedGroupId: {
      type: Array,
      required: true
    }
  },
  inject: ["mess"]
};
</script>

<style lang="scss">
@import "./main.scss";
</style>